<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Training & Tutorial</h2>
			<v-btn color="primary" @click="showDialogAdd">Add</v-btn>
		</div>
		<div>
			<v-text-field 
				v-model="search" 
				append-icon="mdi-magnify" 
				label="Search" 
				hide-details 
				solo 
				clearable
				@keyup="list"
				@click:clear="clearSearch"
			></v-text-field>
		</div>
		<v-card>
			<v-card v-for="(item, idx) in entityList" :key="idx" style="margin-top: 20px">
				<v-card-title draggable @dragstart="drag(idx)" @drop="drop(idx)" @dragover="allowDrop">
					<strong>{{ item.heading }}</strong>
					<div class="d-flex justify-end" style="margin-left: 20px">
						<v-btn icon @click="showDialogEditHeading(item)">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
						<v-btn icon @click="showDialogDelete(item.id, null)">
							<v-icon color="red">mdi-delete</v-icon>
						</v-btn>
					</div>
				</v-card-title>
				<v-card-text>
					<v-expansion-panels>
						<v-expansion-panel
							v-for="(data, index) in item.contentList"
							:key="index"
							color="white"
							style="border-style: solid; border-color: white"
						>
							<v-expansion-panel-header
								color="gr"
								style="padding: 0px"
								draggable
								@dragstart="dragChild(index, item.heading)"
								@drop="dropChild(index, item)"
								@dragover="allowDrop"
							>
								<v-row style="margin-top: 5px">
									<v-col cols="10">
										<span style="color: #0c3188 !important">
											<v-icon>mdi-circle-medium</v-icon>
											<strong>{{ data.title }}</strong>
										</span>
									</v-col>
									<v-col cols="2">
										<div class="d-flex justify-end">
											<v-btn icon @click="showDialogEdit(index, item)">
												<v-icon>mdi-pencil</v-icon>
											</v-btn>
											<v-btn icon dark @click="showDialogDelete(item.id, index)">
												<v-icon color="red">mdi-delete</v-icon>
											</v-btn>
										</div>
									</v-col>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content style="border-style: solid; border-color: #ded9d9; border-width: thin">
								<div style="margin-left: 10px; margin-top: 20px">
									<div><span v-html="data.descDisplay"></span></div>
									<div v-if="data.filename" style="margin-top: 5px">
										<v-btn
											style="background-color: lightblue; padding: 7px; border-radius: 10px"
											@click="openNewTab(data.filename)"
										>
											<v-icon color="red">mdi-file-pdf-box</v-icon>
											{{ data.title }}
										</v-btn>
									</div>
								</div>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-card-text>
			</v-card>
		</v-card>

		<v-dialog v-model="dialog" persistent max-width="700">
			<v-card>
				<v-card-title v-if="entity.index == null">Add New Training & Tutorial</v-card-title>
				<v-card-title v-else>Edit New Training & Tutorial</v-card-title>
				<v-card-text>
					<v-form v-model="valid" @submit="add">
						<v-combobox
							v-model="entity.heading"
							:items="headingList"
							label="Select a heading or create a new one"
							small-chips
							deletable-chips
							:rules="[(v) => !!v || 'Heading is required']"
							required
						></v-combobox>
						<v-text-field label="Title" v-model="entity.title" :rules="[(v) => !!v || 'Title is required']" required></v-text-field>
						<v-textarea
							label="Description"
							v-model="entity.desc"
							:rules="[(v) => !!v || 'Description is required']"
							required
						></v-textarea>
						<v-row>
							<v-col cols="12" sm="3">
								<v-select v-model="type" :items="['Upload', 'URL']" label="Type"></v-select>
							</v-col>
							<v-col cols="12" sm="9" v-if="type === 'Upload'">
								<input ref="attachment1" type="file" accept="application/pdf" @change="upload" style="display: none" />
								<v-text-field
									v-model="filename"
									label="Upload File"
									prepend-icon="mdi-image"
									@click="openBrowser()"
									readonly
									:rules="[(v) => !!v || 'File pdf is required']"
								>
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="9" v-else>
								<v-text-field
									v-model="entity.file"
									prepend-icon="mdi-image"
									label="URL"
									hint="Please input url"
									:rules="[(v) => !!v || 'File URL is required']"
								></v-text-field>
							</v-col>
						</v-row>

						<div class="d-flex justify-end">
							<v-btn color="primary" style="margin-right: 10px" @click="clearDialog"> cancel </v-btn>
							<v-btn :disabled="!valid" color="primary" type="submit"> save </v-btn>
						</div>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit" persistent max-width="700">
			<v-card>
				<v-card-title>Edit Heading</v-card-title>
				<v-card-text>
					<v-form @submit="updateHeading">
						<v-text-field label="Heading" v-model="headingEdit" :rules="[(v) => !!v || 'Heading is required']" required></v-text-field>

						<div class="d-flex justify-end">
							<v-btn color="primary" style="margin-right: 10px" @click="clearDialogEdit"> cancel </v-btn>
							<v-btn color="primary" type="submit"> save </v-btn>
						</div>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";

export default {
	data() {
		return {
			entityList: [],
			entityOriList: [],
			entity: {},
			dialog: false,
			dialogEdit: false,
			headingList: [],
			type: "URL",
			filename: "",
			attachment1: null,
			headingEdit: null,
			idEdit: null,
			indexTargetDrag: 0,
			indexTargetChildDrag: 0,
			headingDrag: null,
			valid: true,
			search: ""
		};
	},
	mounted: function () {
		this.list();
	},
	methods: {
		list() {
			axios.post("/system/trainingAndTutorial/list",{ keyword: this.search }).then((response) => {
				if (response.data) {
					this.entityList = response.data;
					this.entityOriList = this.$root.clone(this.entityList);
					this.listHeading();
					this.setDesc();
				}
			});
		},
		listHeading() {
			this.headingList = [];
			for (let entity of this.entityList) {
				this.headingList.push(entity.heading);
			}
		},
		openNewTab(file) {
			window.open(file, "_blank");
		},
		showDialogAdd() {
			this.entity.heading = "";
			this.entity.index = null;
			this.dialog = true;
		},
		add() {
			let id = this.findIdByHeading(this.entity.heading);
			if (id == null) {
				let formData = new FormData();
				formData.append("entity", JSON.stringify({ heading: this.entity.heading }));
				formData.append("entityContent", JSON.stringify({ title: this.entity.title, desc: this.entity.desc, filename: this.entity.file }));
				if (this.attachment1) {
					formData.append("attachment1", this.attachment1);
				}

				axios.post("/system/trainingAndTutorial/add", formData).then((response) => {
					if (response.data) {
						if (this.entity.index !== null) {
							axios.post("/system/trainingAndTutorial/delete", { id: this.entity.id, index: this.entity.index }).then(() => {
								this.clearDialog();
							});
						} else {
							this.clearDialog();
						}
					}
				});
			} else {
				if (this.entity.index == null) {
					this.entity.index = null;
				}
				if (this.entity.id == id) {
					this.entity.idOld = null;
				} else {
					this.entity.idOld = this.entity.id;
					this.entity.id = id;
				}
				this.update();
			}
		},
		update() {
			let formData = new FormData();
			formData.append("entity", JSON.stringify({ id: this.entity.id, heading: this.entity.heading }));
			formData.append("entityContent", JSON.stringify({ title: this.entity.title, desc: this.entity.desc, filename: this.entity.file }));
			formData.append("index", this.entity.index);
			if(this.entity.idOld){
				formData.append("idOld", this.entity.idOld);
			}

			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/trainingAndTutorial/edit", formData).then((response) => {
				if (response.data) {
					this.clearDialog();
				}
			});
		},
		updateHeading() {
			axios.post("/system/trainingAndTutorial/edit/heading", { id: this.idEdit, heading: this.headingEdit }).then(() => {
				this.clearDialogEdit();
			});
		},
		findIdByHeading(heading) {
			var id = null;
			for (let data of this.entityList) {
				if (data.heading == heading) {
					id = data.id;
					break;
				}
			}
			return id;
		},
		showDialogEdit(index, item) {
			this.entity = {
				id: item.id,
				heading: item.heading,
				title: item.contentList[index].title,
				desc: item.contentList[index].desc,
				file: item.contentList[index].filename,
				index: index
			};
			this.dialog = true;
		},
		showDialogEditHeading(item) {
			this.idEdit = item.id;
			this.headingEdit = item.heading;
			this.dialogEdit = true;
		},
		showDialogDelete(id, index) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/trainingAndTutorial/delete", { id: id, index: index }).then(() => {
					this.list();
				});
			}
		},
		upload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
				this.filename = files[0].name;
			} else {
				this.attachment1 = null;
			}
		},
		openBrowser() {
			this.$refs.attachment1.click();
		},
		clearDialog() {
			this.entity = {};
			this.dialog = false;
			this.list();
			this.filename = "";
		},
		clearDialogEdit() {
			this.idEdit = null;
			this.heading = null;
			this.dialogEdit = false;
			this.list();
		},
		allowDrop(ev) {
			if (!this.search) {
				ev.preventDefault();
			}
		},
		drag(index) {
			this.headingDrag = null;
			this.indexTargetDrag = index;
		},
		drop(index) {
			if (this.headingDrag == null) {
				var tmp = this.entityList.splice(this.indexTargetDrag, 1);
				this.entityList.splice(index, 0, tmp[0]);
				this.updateSortOrder();
			}
		},
		dragChild(index, heading) {
			this.indexTargetChildDrag = index;
			this.headingDrag = heading;
		},
		dropChild(index, item) {
			if (item.heading == this.headingDrag) {
				var tmp = item.contentList.splice(this.indexTargetChildDrag, 1);
				item.contentList.splice(index, 0, tmp[0]);
				this.updateSortOrderChild(item);
			}
		},
		updateSortOrder() {
			var editDataList = [];
			for (let i = 0; i < this.entityOriList.length; i++) {
				editDataList.push({
					id: this.entityList[i].id,
					sortOrder: this.entityOriList[i].sortOrder
				});
			}

			axios
				.post("/system/trainingAndTutorial/edit/sortOrder", {
					editDataList: editDataList
				})
				.then((response) => {
					if (response.data) {
						this.list();
					}
				})
				.catch(() => {});
		},
		updateSortOrderChild(item) {
			axios
				.post("/system/trainingAndTutorial/edit/sortOrder/child", {
					entity: item
				})
				.then((response) => {
					if (response.data) {
						this.list();
					}
				})
				.catch(() => {});
		},
		setDesc() {
			for (let data of this.entityList) {
				for (let content of data.contentList) {
					let desc = content.desc
					desc = desc.replace(/\n/g, "</p><p>");
					desc = "<p>" + desc + "</p>";
					content.descDisplay = desc;
				}
			}
		},
		clearSearch() {
			this.search = "";
			this.list();
		},
	}
};
</script>
